module.exports = __webpack_public_path__ + "img/ring-bell.7d54beed.svg";